var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoshippoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.675C24 7.0875 21.9 4.9875 19.3125 4.9875C17.1 4.9875 16.3875 5.85 14.025 6.15C12.6 6.3375 12.675 5.55 11.1 5.55C9.9375 5.55 8.7375 6.15 8.7375 6.15C8.7375 6.15 7.6125 4.8 6.975 4.9875C6.1125 5.2875 6.975 7.9125 6.975 7.9125C6.975 7.9125 6.375 9.075 5.2125 10.275C4.35 11.1375 2.2875 11.625 1.2375 11.925C1.275 6.525 5.7 2.1 11.1 2.1C13.4625 2.1 15.6 2.925 17.325 4.3125C17.7375 4.2 18.2625 4.125 18.7875 4.0875C16.8 2.1375 14.1 0.9375 11.025 0.9375C4.9875 0.9375 0 5.925 0 12.0375C0 18.15 4.9875 23.0625 11.1 23.0625C16.425 23.0625 20.8875 19.3125 21.9 14.25C21.4125 14.475 20.9625 14.7375 20.475 14.9625C19.2375 18.825 15.7125 21.7125 11.4375 21.9C12.0375 20.8875 13.3875 19.0125 15.15 17.325C19.0875 13.5375 24 14.1375 24 9.675ZM11.9625 9.1125C11.475 9.1125 11.1 8.7 11.1 8.25C11.1 7.7625 11.5125 7.3875 11.9625 7.3875C12.45 7.3875 12.825 7.8 12.825 8.25C12.8625 8.7 12.45 9.1125 11.9625 9.1125Z",
    fill: "#3B474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoshippoIcon);
export default __webpack_public_path__ + "static/media/goshippo-icon.ea3da2c762a3e0357f8ead9b665de495.svg";
export { ForwardRef as ReactComponent };